import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 text-center mb-6">
            {aboutInfo.title}
          </h2>
          <div className="bg-background-50 rounded-xl p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.content}
            </p>
            <div className="flex flex-wrap items-center gap-6 mt-6 pt-6 border-t border-background-200">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-sm text-primary-600"></i>
                </div>
                <span className="text-sm text-foreground-600">收录<strong>12,000+</strong>部韩漫</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-user-heart-line text-sm text-accent-600"></i>
                </div>
                <span className="text-sm text-foreground-600">服务<strong>100万+</strong>漫迷</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-timer-flash-line text-sm text-secondary-600"></i>
                </div>
                <span className="text-sm text-foreground-600">日更<strong>200+</strong>话内容</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}